import FJTextStyle from './FJTextStyle';
import FJOutline from './style/FJOutline';
import FJBase from './style/FJBase';

class FJTextStyleSplice extends FJTextStyle {
    initStyles(props = {}) {
        let shadow = new FJBase({
            ...props,
            offset: 8,
            angle: 44,
            color: '#ABFBFF',
            position: 'relative',
        });

        let textOutline = new FJOutline({
            ...props,
            width: 20,
            color: '#00D1EF',
            textColor: 'transparent',
            position: 'absolute',
            widthRef: 1200,
        });

        this._styles = [shadow, textOutline];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{offset: *, outlineColor: *, width: *, direction: *}}
     */
    getAdjustInfo() {
        let shadow = this._styles[0];
        let outline = this._styles[1];
        return {
            color: [shadow.color],
            width: outline.width,
            offset: shadow.offset * 2,
            direction: shadow.angle,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        if (info.color[0] !== '') {
            this._styles[0].color = info.color[0];
        }
        if (info.width !== '') {
            this._styles[1].width = info.width;
        }
        if (info.offset !== '') {
            this._styles[0].offset = info.offset / 2;
        }
        if (info.direction !== '') this._styles[0].angle = info.direction;
    }

    /**
     * @description 设置color
     * @param color
     */
    setColor(color) {
        this._styles[1].color = color;
    }

    /**
     * @desc 获取实际的文字dom对象 <排除样式辅助>
     */
    getActualLayer() {
        if (this._enableStyle) {
            return this._baseStyle.getActualLayer();
        }

        if (!this._styles[1]) return null;

        return this._styles[1].getActualLayer();
    }

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param options
     */
    addToView(view, textData, options) {
        if (!view) return;
        if (this._enableStyle) {
            this._baseStyle.addToView(view, textData, options);
            return;
        }

        this._styles.forEach((style, index) => {
            style.addToView(view, textData, { ...options, isAddToSupportLayer: index !== this._styles.length - 1 });
        });
    }
}

export default FJTextStyleSplice;
